import React from 'react';
const IconActionMoveToFolder = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6 13H14.86L12.34 16H14.95L18.31 12L14.94 8H12.33L14.85 11H6V13Z" fill="#2D2E2E"/>
<path d="M12.47 4L11.21 2.5H2V16H4V4.5H10.27L11.53 6H20V18H2V20H22V4H12.47Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconActionMoveToFolder;